import { render, staticRenderFns } from "./Salutation.vue?vue&type=template&id=6368af60&"
import script from "./Salutation.vue?vue&type=script&lang=js&"
export * from "./Salutation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6368af60')) {
      api.createRecord('6368af60', component.options)
    } else {
      api.reload('6368af60', component.options)
    }
    module.hot.accept("./Salutation.vue?vue&type=template&id=6368af60&", function () {
      api.rerender('6368af60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/Salutation.vue"
export default component.exports